import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'zag-popover-panel',
  imports: [NgTemplateOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './popover-panel.component.scss',
  host: {
    role: 'dialog',
    tabindex: '-1',
    '[id]': 'panelId()',
    '[attr.aria-label]': 'label() || null',
  },
  template: `<ng-container *ngTemplateOutlet="content()" />`,
})
export class PopoverPanelComponent {
  readonly content = input.required<TemplateRef<unknown>>();
  readonly panelId = input.required<string>();
  readonly label = input('');
}
